"use client";

import React, { useContext, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { IntroContext, LiveSessionContext, ThemeContext } from "../../context";
import LiveSessionLectureShimmer from "../../components/livesession/LiveSessionLectureShimmer";
import LiveSessionPollShimmer from "../../components/livesession/LiveSessionPollShimmer";
import dynamic from "next/dynamic";
const CommentsArea = dynamic(
  () => import("../../containers/livesession/CommentsArea")
);
import { motion } from "framer-motion";
import selfStudyLottie from "../../public/assets/lottie/self_study.json";
// import Lottie from "lottie-react-web";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });

export default function Index({ setVisibleNavbar }) {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 500px)" });
  const [_, setShowMenuItem] = useContext(LiveSessionContext).showMenuItem;
  const [hasNoSessions] = useContext(LiveSessionContext).hasNoSessions;
  const [isDark] = useContext(ThemeContext).theme;
  const [, setShowLandingPage] = useContext(IntroContext).showLandingPage;

  useEffect(() => {
    setShowLandingPage(false);
    setVisibleNavbar(true);
    if (isSmallScreen) {
      setShowMenuItem(true);
    } else {
      setShowMenuItem(false);
    }
  }, [isSmallScreen]);

  if (hasNoSessions)
    return isSmallScreen ? (
      <div></div>
    ) : (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="col-lg-12 col-md-12 col-xs-12"
        id="livesession__content"
      >
        <div
          className={"w-full h-full flex flex-col justify-center items-center"}
        >
          <div className="w-70vw max-w-[500px]">
            <Lottie options={{ animationData: selfStudyLottie, loop: true }} />
          </div>
          <h2 className="text-black dark:text-white mt-5 font-roboto mb-2">
            Self Study Day!
          </h2>
          <p className="text-black text-sm dark:text-white text-opacity-40 dark:text-opacity-40">
            Revise concepts, practice questions, and eat well.
          </p>
          <p className="text-black text-sm dark:text-white text-opacity-40 dark:text-opacity-40">
            Make it count!
          </p>
        </div>
      </motion.div>
    );

  return isSmallScreen ? (
    <div></div>
  ) : (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="col-lg-12 col-md-12 col-xs-12"
      id="livesession__content"
    >
      <div className={"session-container"}>
        <div className="session__area--holder">
          <div
            className="session__area"
            style={{
              background: isSmallScreen
                ? "#202020"
                : isDark
                ? "#202020"
                : "white",
              width: "100%",
              aspectRatio: 1.77777,
            }}
          >
            <LiveSessionLectureShimmer />
          </div>
        </div>
        <div className="quiz__sidebar">
          <LiveSessionPollShimmer isDarkMode={isSmallScreen ? true : isDark} />
        </div>
        <div id="comments__card__wrapper">
          <CommentsArea sessionExists={true} />
        </div>
      </div>
    </motion.div>
  );
}

Index.getLayout = "LiveClasses";

// function(page, props) {
// 	return <LiveSessionLayout {...props}>
// 		{page}
// 	</LiveSessionLayout>
// }

// Index.Layout = LiveSessionLayout;
// Index.type = PAGE_TYPES.LIVE_CLASSES
